import type { FirebaseOptions } from 'firebase/app';

export enum ENV {
  // 本地开发
  DEBUG = 'DEBUG',
  // PRE环境 k8s
  PRE_K8S = 'PRE_K8S',
  // PROD环境 k8s
  PROD_K8S = 'PROD_K8S',
  // DEV环境 k8s
  DEV_K8S = 'DEV_K8S'
}

const APP_ENV = process.env.NEXT_PUBLIC_APP_ENV as ENV;

export function gatewayHost(): string {
  switch (APP_ENV) {
    case ENV.DEBUG:
    case ENV.DEV_K8S:
      return 'https://mindos-devusk8s.mindverse.ai/gate';
    case ENV.PRE_K8S: {
      return 'https://mindos-prek8s.mindverse.ai/gate';
    }
    case ENV.PROD_K8S: {
      return 'https://app.mindos.com/gate';
    }
  }
}

export function chatHost(): string {
  return gatewayHost() + '/chat';
}

export function innerHost(): string {
  const override = process.env.NEXT_PUBLIC_PROXY_TARGET;

  if (override) {
    return override;
  }

  return gatewayHost() + '/in';
}

export function logHost(): string {
  return gatewayHost() + '/log';
}

export function ummHost(): string {
  return gatewayHost() + '/umm';
}

export function outHost(): string {
  return gatewayHost() + '/out';
}

export function labHost(): string {
  return gatewayHost() + '/lab';
}

export function isDevENV(): boolean {
  return APP_ENV === ENV.DEV_K8S;
}

export function isDebug(): boolean {
  return APP_ENV === ENV.DEBUG;
}

export function firebaseKey(): string {
  switch (APP_ENV) {
    case ENV.DEV_K8S:
    case ENV.DEBUG: {
      return 'AIzaSyChZOG7oS9HoAOQGSp0dDP_R7FkrMzCGSU';
    }
    case ENV.PRE_K8S:
    case ENV.PROD_K8S: {
      return 'AIzaSyDv1x-9ZtFnaYVh8VuJGZV1d_0LlJ_a6Ag';
    }
  }
}

export function firebaseConfig(): FirebaseOptions {
  switch (APP_ENV) {
    case ENV.DEV_K8S:
    case ENV.DEBUG: {
      return {
        apiKey: 'AIzaSyChZOG7oS9HoAOQGSp0dDP_R7FkrMzCGSU',
        authDomain: 'mindos-test.firebaseapp.com',
        projectId: 'mindos-test',
        storageBucket: 'mindos-test.appspot.com',
        messagingSenderId: '65686111561',
        appId: '1:65686111561:web:557b56c6d4ea1cdc260698',
        measurementId: 'G-QF2D4Z7JRR'
      };
    }
    case ENV.PRE_K8S: {
      return {
        apiKey: 'AIzaSyDv1x-9ZtFnaYVh8VuJGZV1d_0LlJ_a6Ag',
        authDomain: 'auth-mindos.mindverse.ai',
        projectId: 'mindos-d3299',
        storageBucket: 'mindos-d3299.appspot.com',
        messagingSenderId: '730397711754',
        appId: '1:730397711754:web:00c91681bfcf00e098fc73',
        measurementId: 'G-MDCC7BHCT1'
      };
    }
    case ENV.PROD_K8S: {
      return {
        apiKey: 'AIzaSyDv1x-9ZtFnaYVh8VuJGZV1d_0LlJ_a6Ag',
        authDomain: 'auth.me.bot',
        projectId: 'mindos-d3299',
        storageBucket: 'mindos-d3299.appspot.com',
        messagingSenderId: '730397711754',
        appId: '1:730397711754:web:00c91681bfcf00e098fc73',
        measurementId: 'G-MDCC7BHCT1'
      };
    }
  }
}

export function isProduct(): boolean {
  return APP_ENV === ENV.PRE_K8S || APP_ENV === ENV.PROD_K8S;
}

export function isTrulyProd(): boolean {
  // return true;

  return APP_ENV === ENV.PROD_K8S;
}

// WebView 相关工具函数
interface ReactNativeWebView {
  postMessage: (message: string) => void;
}

declare global {
  interface Window {
    ReactNativeWebView?: ReactNativeWebView;
  }
}

/**
 * 检测是否在客户端 WebView 中运行
 */
export function isInWebView(): boolean {
  return typeof window !== 'undefined' && !!window.ReactNativeWebView;
}

/**
 * 在默认浏览器中打开 URL（WebView 中）或直接跳转（普通浏览器）
 */
export function navigateToUrl(url: string): void {
  if (isInWebView()) {
    window.ReactNativeWebView!.postMessage(
      JSON.stringify({
        funName: 'openBrowser',
        args: [url]
      })
    );
  } else {
    window.location.href = url;
  }
}

/**
 * 在默认浏览器中打开 URL 并关闭当前 WebView 页面
 * 用于 OAuth 等需要跳转后关闭当前页面的场景
 */
export function navigateToUrlAndPop(url: string): void {
  if (isInWebView()) {
    window.ReactNativeWebView!.postMessage(
      JSON.stringify({
        funName: 'openBrowser',
        args: [url]
      })
    );
    window.ReactNativeWebView!.postMessage(
      JSON.stringify({
        funName: 'MbNavigation.pop'
      })
    );
  } else {
    window.location.href = url;
  }
}
